export const deClientPortalHandoverModal = {
    imageAlt: 'teilen',
    actions: {
        confirm: 'Teilen',
    },
    items: {
        requestNewDraft: 'Neuen Entwurf gemäß der Anmerkungen anfordern',
    },
    infoText:
        'Sie können weiterhin Anmerkungen zu diesem Entwurf hinzufügen, bearbeiten und löschen. Ihre Gutachterin/Ihr Gutachter wird sofort benachrichtigt.',
}
